import { render } from "./auto-login.html?vue&type=template&id=564590f4&scoped=true&ts=true&external"
import script from "./auto-login.ts?vue&type=script&lang=ts&external"
export * from "./auto-login.ts?vue&type=script&lang=ts&external"

import "./auto-login.scss?vue&type=style&index=0&id=564590f4&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564590f4"]])

export default __exports__